export { makeTransformSapiRoomsResponse } from "./transformSapiRoomsResponse";